import { render, staticRenderFns } from "./view_pv.vue?vue&type=template&id=f11005e4&"
import script from "./view_pv.vue?vue&type=script&lang=js&"
export * from "./view_pv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports